import React from "react";
import PropTypes from "prop-types";

// components
import CardInfoIcon from "../Components/Cards/CardInfoIcon.js";

export default function Engagement({ infoCards }) {
  return (
    <>
      <section className="pb-20 bg-blueGray-100">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap">
            {infoCards.map((prop, key) => {
              return (
                <div
                  className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center"
                  key={key}
                >
                  <CardInfoIcon {...prop} />
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

Engagement.defaultProps = {
  infoCards: [],
};
Engagement.propTypes = {
  infoCards: PropTypes.arrayOf(PropTypes.object),
};
